module.exports = __webpack_public_path__ + "img/数字化运营.7b021f02.png";